document.addEventListener('DOMContentLoaded', () => {
  // Only run on desktop (not touch devices)
  if (window.matchMedia('(pointer: fine)').matches) {
    const menuItems = document.querySelectorAll('details');

    menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        item.setAttribute('open', true);
      });

      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(pointer: fine)').matches) return; // run only on desktop

  // Find the top-level details that has summary text "Get Involved"
  const detailsEls = Array.from(document.querySelectorAll('details'));

  const getInvolvedDetails = detailsEls.find(d => {
    const summary = d.querySelector('summary');
    return summary && summary.textContent.trim().toLowerCase() === 'get involved';
  });

  if (!getInvolvedDetails) return;

  // find the first-level submenu UL inside "Get Involved"
  const firstLevelUl = getInvolvedDetails.querySelector('ul, .header__submenu');
  if (!firstLevelUl) return;

  // target the second li in that first-level submenu
  const secondLi = firstLevelUl.querySelector('li:nth-child(2)');
  if (!secondLi) return;

  // the second li may contain a <details> for its own submenu or a nested ul
  const nestedDetails = secondLi.querySelector('details');
  const nestedUl = secondLi.querySelector('ul');

  // Add a class to the nested submenu container for special left positioning
  if (nestedDetails) {
    const nestedUlInside = nestedDetails.querySelector('ul');
    if (nestedUlInside) nestedUlInside.classList.add('submenu-pop-left');
    nestedDetails.classList.add('submenu-parent-pop-left');
  } else if (nestedUl) {
    nestedUl.classList.add('submenu-pop-left');
    secondLi.classList.add('submenu-parent-pop-left');
  }
});